import { Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { DomainDataService } from '../../../../../services';
import { FinanceCostPageService } from '../../finance-cost.page.service';
import { getSetup } from './grid/get-setup';
import { TrimesterCost } from '@interfaces';


@Component({
	selector: 'finance-cost-trimester-view-part',
	standalone: true,
	templateUrl: './finance-cost-trimester-view.part.html',
	styleUrls: ['./finance-cost-trimester-view.part.scss'],
	imports: [
		GridContentWidget
	]
})
export class FinanceCostTrimesterViewPart {

	private readonly service = inject(FinanceCostPageService);
	private util = inject(UtilityService);
	private readonly domainData = inject(DomainDataService);
	public setup = getSetup(this.service, this.util, this.domainData);
	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.service.layout()) return { layout: this.service.layout()!, viewSelector: true };
		return undefined;
	});

	public readonly costs = computed(() => { return <TrimesterCost[]>[] });


}